import script from "./ShopTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopTable.vue?vue&type=script&lang=ts&setup=true"

import "./ShopTable.vue?vue&type=style&index=0&id=7b169357&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b169357"]])

export default __exports__